export default __webpack_public_path__ + "static/media/Logo-black.97648039.svg";